import { gql } from "@apollo/client";

export const UPDATE_EVENT_SESSIONS_REGISTRATION_ATTENDANCES_MUTATION = gql`
  mutation UpdateEventSessionsRegistrationAttendances(
    $attendances: [BackofficeEventsUpdateEventSessionsRegistrationAttendanceInput!]!
  ) {
    updateEventSessionsRegistrationAttendances(attendances: $attendances) {
      success
      message
      eventSessionsRegistrations {
        id
        attended
      }
    }
  }
`;

const attendanceSessionFields = `
  sessions {
    id
    orderKey
    startsAt
    endsAt
    registrations {
      id
      attended
      registration {
        id
        canceledAt
        person {
          id
          pgaId
          profilePhoto
          displayName
          mainProgramType {
            name
          }
        }
      }
    }
  }
`;

export const UNIVERSITY_ATTENDANCE_EVENT_QUERY = gql`
  query GetUniversityBackofficeEventForAttendance($slug: String!) {
    event(slug: $slug) {
      id
      status
      title
      sessionCount
      activityTypeSummary {
        id
        title
      }
      eventTypeSummary {
        id
        name
      }
      section {
        permissions {
          manageEvents
        }
      }
      collectsAttendance
      finalizedAt
      ${attendanceSessionFields}
    }
  }
`;

export const EVENT_QUERY = gql`
  query GetBackofficeEvent($slug: String!) {
    event(slug: $slug) {
      id
      status
      title
      sessionCount
      eventType {
        id
        name
      }
      section {
        permissions {
          manageEvents
        }
      }
      activityType {
        id
        title
        sectionAvailability
        createsEvent
      }
      collectsAttendance
      finalizedAt
      ${attendanceSessionFields}
    }
  }
`;
